module.exports = __webpack_public_path__ + "img/saotomeandprincipe.617a7974.svg";